module.exports = __webpack_public_path__ + "static/media/group_copy_3@3x.a17161b8.png";